import {
  BattlePassKeyType,
  BattlePassPrizeHistoryType,
  BattlePassPrizeType,
  BattlePassType,
  RandomBattlePassPrize
} from '@apeiron/temp'
import * as yup from 'yup'

const battlePass: yup.SchemaOf<BattlePassType> = yup
  .object({
    startAt: yup.string().default(''),
    endAt: yup.string().default(''),
    battlePassType: yup.string().default(''),
    currentEXP: yup.number().default(0),
    displayName: yup.string().default(''),
    maximumLevel: yup.number().default(0),
    scheduleID: yup.string().default(''),
    fortuneKeys: yup.array().of(yup.string().default('')).default([]),
    seasonID: yup.string().default('')
  })
  .noUnknown(true)

export const battlePassSchema = yup.array().of(battlePass)

const battlePassKey: yup.SchemaOf<BattlePassKeyType> = yup
  .object({
    balance: yup.number().default(0),
    keyAssetName: yup.string().default('')
  })
  .noUnknown(true)

export const battlePassKeySchema = yup.array().of(battlePassKey)

export const randomBattlePassPrizeSchema: yup.SchemaOf<RandomBattlePassPrize> =
  yup
    .object({
      prizeAssetName: yup.string().default(''),
      qty: yup.number().default(0)
    })
    .noUnknown(true)

export const battlePassPrize: yup.SchemaOf<BattlePassPrizeType> = yup
  .object({
    prizeAssetName: yup.string().default(''),
    totalQty: yup.number().default(0)
  })
  .noUnknown(true)

export const battlePassPrizeSchema = yup.array().of(battlePassPrize)

export const battlePassPrizeHistorySchema: yup.SchemaOf<BattlePassPrizeHistoryType> =
  yup
    .object({
      seasonID: yup.string().default(''),
      prizeID: yup.string().default(''),
      drawDate: yup.string().default(''),
      prizeAssetName: yup.string().default(''),
      itemQty: yup.number().default(0),
      useKeyAssetName: yup.string().default('')
    })
    .from('prizeItem.prizeAssetName', 'prizeAssetName')
    .from('prizeItem.itemQty', 'itemQty')
    .noUnknown(true)
